import type { getOneOrderOutput } from "@/api/custom_types";
import {
	OrderDetailsInfoBalance,
	OrderDetailsInfoDetail,
	OrderDetailsInfoHistoryStatus,
} from "./components";

interface OrderDetailsInfoProps {
	data: getOneOrderOutput;
}

const OrderDetailInfo = ({ data }: OrderDetailsInfoProps) => {
	return (
		<div className="grid grid-cols-1 gap-4 md:grid-cols-2 mb-10">
			<OrderDetailsInfoDetail order={data} />

			<OrderDetailsInfoHistoryStatus order={data} />

			<OrderDetailsInfoBalance order={data} />
		</div>
	);
};

export default OrderDetailInfo;
